"use client";

export { default, useExtrasContext } from "../../../contexts/ExtrasProvider";
